import React, { Component } from 'react';
import { connect } from 'react-redux';
import { push } from 'react-router-redux';
import { mergeDeepLeft, clone } from 'ramda';
import Input from '../../common/Input';
import Select from '../../common/Select';
import Breadcrumbs from '../../common/Breadcrumbs';
import '../../css/forms/default-forms.css';
import fields from './fields';
import approve from 'approvejs';
import getPassword from '../../utils/getPassword';
import { processFields } from '../../utils/prePost';
import { createUser } from '../../api/users';
import CKEditorComponent from "../../сomponents/CKEditor";

export class PeopleAdd extends Component {

  constructor(props) {
    super(props);
    this.state = {
      submit: false,
      errors: [],
      fields: fields,
    };
    this.submit = this.submit.bind(this);
    this.updateCustomerValue = this.updateCustomerValue.bind(this); // Custom for this container
    this.validate = this.validate.bind(this);
    this.validateField = this.validateField.bind(this);
    this.submitForm = this.submitForm.bind(this);
    this.generatePassword = this.generatePassword.bind(this); // Custom for this container
    this.changeFormValue = this.changeFormValue.bind(this);
    this.cancel = this.cancel.bind(this);

    this.ckeEditorSignature = element => {
      this.signatureRef = element;
    };    
  }

  validate(e, field) {
    let fields = this.validateField(e, field, this.state.fields);
    this.setState({
      fields: fields,
    });
    return false;
  }

  validateField(e, field, fields) {
    e.preventDefault();
    field.value = '';
    let result = approve.value(e.target.value, field.rules);
    field.errors = [];
    if (result.errors.length > 0) {
      field.errors = Array.from(result.errors);
      field.value = '';
    } else {
      field.value = e.target.value;
    }
    fields = fields.map(item => {
      if (item.name === field.name) {
        return field;
      } else {
        return item;
      }
    });
    return fields;
  }

  submitForm(e, fields) {
    e.preventDefault();
    let check = true;
    for (let field in fields) {
      fields[field].errors = [];
      let result = approve.value(fields[field].value, fields[field].rules);
      if (result.errors.length > 0) {
        check = false;
        fields[field].errors = Array.from(result.errors);
      }
    }
    return {
      fields,
      check,
    };
  }

  submit(e) {
    e.preventDefault();
    const signature = this.state.fields['signature'];
    if (signature) {
      signature.value = this.signatureRef.editor.getData();
    }

    let result = this.submitForm(e, this.state.fields);
    if (result.check === false) {
      this.setState({
        fields: result.fields,
      });
    } else {
      this.props.saveForm(processFields(this.state.fields));
    }
    return false;
  }

  updateCustomerValue(newValue) {
    this.setState({
      selectValue: newValue
    });
  }

  getTypes() {
    return [
      {
        value: 1,
        text: 'Administrator',
      },
      {
        value: 2,
        text: 'Business Manager',
      },
      {
        value: 3,
        text: 'Sales Person',
      },
      {
        value: 4,
        text: 'Worker',
      },
      {
        value: 5,
        text: 'Client',
      },
    ];
  }

  generatePassword(e) {
    e.preventDefault();
    this.setState(mergeDeepLeft({
      fields: {
        password: {
          value: getPassword(),
        },
      },
    }, this.state));
  }

  changeFormValue(field, newObject) {
    let stateClone = clone(this.state);
    stateClone.fields[field] = newObject;
    this.setState(mergeDeepLeft(stateClone, this.state));
  }

  cancel() {
    this.props.goToPeople();
  }

  render() {
    return (
      <div className="row">
        <div className="col">
          <Breadcrumbs list={[
            { url: '/pages/dashboards', icon: 'dashboard', name: 'Dashboard' },
            { url: '/pages/people', icon: 'accessibility', name: 'People' },
            { icon: 'person_add', name: 'Add People' },
          ]} />
          <div className="card rounded">
            <div className="card-header rounded-top">
              Add User
            </div>
            <div className="card-block">
              <div className="col-12" style={{ paddingBottom: '40px' }}>
                <button
                  className={'btn btn-danger btn-outline float-right'}
                  style={{ marginLeft: '10px' }}
                  onClick={this.cancel}
                >
                  <i className="fa fa-remove"></i>
                  <span style={{ paddingLeft: '3px' }}>Cancel</span>
                </button>
                <button className={'btn btn-success btn-outline float-right'} onClick={this.submit}>
                  <i className="fa fa-check"></i>
                  <span style={{ paddingLeft: '3px' }}>Save & Continue</span>
                </button>
              </div>
              <form onSubmit={this.submit}>
                <div className="col-12">
                  <Select
                    options={this.getTypes()}
                    field={this.state.fields['type']}
                    onChange={this.changeFormValue}
                  />
                  <Input
                    field={this.state.fields['username']}
                    onChange={this.changeFormValue}
                  />
                  <Input
                    field={this.state.fields['firstname']}
                    onChange={this.changeFormValue}
                  />
                  <Input
                    field={this.state.fields['lastname']}
                    onChange={this.changeFormValue}
                  />
                  <Input
                    field={this.state.fields['email']}
                    onChange={this.changeFormValue}
                  />
                  <Input
                    field={this.state.fields['phone']}
                    onChange={this.changeFormValue}
                  />
                  <Input
                    field={this.state.fields['password']}
                    onChange={this.changeFormValue}
                  />
                  <button className={'btn btn-default btn-outline'} style={{ marginBottom: '10px' }} onClick={this.generatePassword}>
                    <i className="fa fa-key"></i>
                    <span style={{ paddingLeft: '3px' }}>Generate</span>
                  </button>
                  <CKEditorComponent
                    field={this.state.fields['signature']}
                    refLink={this.ckeEditorSignature}
                  />                   
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

const mapStateToProps = (state) => {
  return state;
};

const mapDispatchToProps = (dispatch) => {
  return {
    saveForm: (data) => {
      createUser(data)(dispatch);
    },
    goToPeople: () => {
      dispatch(push('/pages/people'));
    }
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(PeopleAdd);



// WEBPACK FOOTER //
// ./src/containers/PeopleAdd/index.js